module.exports = __webpack_public_path__ + "img/camera.a0402973.svg";